import {
  styled,
  flex,
  flexAlignCenter,
  Theme,
  Colors,
  flexCenter,
  flexColumn,
  unit,
  layers
} from '@unfold/theme';
import { IAppContainerProps } from '../common/types';
import { down } from 'styled-breakpoints';

const headerHeight = 60
const mobileBottomTabsHeight = 50

export const AppContainer = styled.div<IAppContainerProps>`
  ${flex}
  ${({ isHidden }): string => isHidden ? 'display: none;' : ''}
  height: 100%;
`;

export const LogoutLink = styled.a`
  cursor: pointer;
  color: ${Colors.BLACK};
  margin-left: ${unit.px(1.5)};
`;

export const MenuContainer = styled.div`
  width: 200px;
  flex: 0 0 200px;
  height: 100%;
  background-color: ${({ theme }): string =>
    theme.name === Theme.LIGHT ? Colors.WHITE : Colors.DG600};
  ${flexColumn}
  padding-bottom: 40px;

  ${down('mobile')} {
    position: fixed;
    bottom: 0;
    width: 100%;
    display: block;
    background-color: #f9f9f9;
    height: ${mobileBottomTabsHeight}px;
    z-index: ${layers.navigation()}
  }
`;

export const LogoWrapper = styled.div`
  ${flexCenter}
  margin-top: 90px;

  ${down('mobile')} {
    display: none;
  }
`;

export const MenuWrapper = styled.div`
  margin-top: 140px;
  flex: 1;

  ${down('mobile')} {
    height: 100%;
    margin: 0;
    padding: 0;
    justify-content: space-around;
  }
`;

export const Content = styled.div`
  flex: 1;
  width: 100%;
`;

export const ContentTop = styled.div`
  ${flexAlignCenter}
  height: ${headerHeight}px;
  justify-content: flex-end;
  padding-right: 55px;
  color: ${Colors.G300};
  font-size: 14px;
  font-weight: 500;
`;

export const ContentBody = styled.div`
  height: 100%;
  max-height: 100%; /* fallback if calc is not supported, may cut off bottom padding */
  max-height: calc(100% - ${headerHeight}px);
  ${down('mobile')} {
    max-height: calc(100% - ${headerHeight + mobileBottomTabsHeight}px);
  }
  overflow-y: auto;
`;
